<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Categories" pageTitleUrl="main-categories" :subTitle="categoryName"></app-breadcrumb>

        <!-- page heading -->
        <div class="row mb-2">
            <div class="col-lg-9 col-md-8 col-sm-6 col-12">
                <p>
                    <span class="h3 md-small-text">Manage Category</span> <br> 
                    <span class="d-none d-md-block">(manage the category and its sub-categories here)</span>
                </p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-right">
                <button @click.prevent="deleteCategoryFxn" class="btn btn-danger form-control">
                    <span><i class="fas fa-trash-alt"></i> Delete Category</span>
                </button>
            </div>
        </div>

        <!-- add sub-category -->
        <div class="row">
            <div class="col-12">
                <div class="card bg-light">
                    <div class="card-body">
                        <h5>New Sub Category</h5>
                        <!-- display alert message desktop view -->
                        <div v-if="msg !== ''" :class="`alert alert-${color} text-center my-2 p-1`" role="alert">
                            <i class="fas fa-exclamation-circle"></i> {{ msg }}
                        </div>
                        <form>
                            <div class="input-group">
                                <input :value="categoryName" type="text" readonly required class="form-control no-lines text-capitalize" placeholder="Category name">
                            </div>
                            <div class="input-group mt-3">
                                <input v-model="subCategoryName" type="text" required class="form-control no-lines" placeholder="Sub category name">
                                <div class="input-group-prepend">
                                    <button @click.prevent="saveSubCategoryFxn" class="input-group-text btn btn-dark-green">
                                        <i class="fas fa-save fa-sm mr-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- available sub-categories -->
        <div class="row">
            <div class="col-12">
                <!-- display category logs -->
                <div class="table-responsive">
                    <table class="table table-hover mt-3">
                        <thead class="bg-silver">
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">SubCategories</th>
                                <th scope="col" class="text-center">Items</th>
                                <th scope="col">Created</th>
                                <th scope="col" class="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="theSubCategories">
                            <tr v-for="(subCategory, i) in theSubCategories" :key="subCategory.id">
                                <th scope="row">{{ i+1 }}.</th>
                                <td class="text-capitalize">{{subCategory.subCategory}}</td>
                                <td class="text-center">{{subCategory.itemsCount}}</td>
                                <td><span class="text-truncate">{{subCategory.joined | moment("MMM D 'YY")}}</span></td>
                                <td class="text-center">
                                    <button class="btn btn-danger" @click.prevent="deleteSubCategoryFxn(subCategory)">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Breadcrumb from '../../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "ManageCategory",
    props: {
        categoryId: {
            type: String,
            required: true
        },
        categoryName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            msg: '',
            color: 'danger',
            subCategoryName: ''
        }
    },
    methods: {
        ...mapActions(['addSubCategoryAction', 'fetchSubCategoriesAction', 'deleteCategoryAction', 'deleteSubCategoryAction']),
        fetchSubCategoriesFxn(theCategoryName) {
            let subCategoryObj = {
                categoryName: theCategoryName
            }
            this.fetchSubCategoriesAction(subCategoryObj).then(() => {}).catch((e) => {})
        },
        saveSubCategoryFxn() {
            this.color = "danger"
            if(this.subCategoryName === ''){ this.msg = "Enter a unique sub-category name!"; return }
            let subCategoryObj = {
                categoryName: this.categoryName,
                subCategoryName: this.subCategoryName
            }
            this.addSubCategoryAction(subCategoryObj)
            .then((data) => {
                if(!data.error){ 
                    this.color = "success" 
                    this.subCategoryName = ""
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.color = "danger"
                this.msg = "Something went wrong while saving the sub-category! Try again"
            })
        },
        deleteCategoryFxn() {
            this.color = "danger"
            let categoryObj = {
                categoryId: this.categoryId,
                categoryName: this.categoryName.toLowerCase()
            }
            // vuejs-dialog usage for pop up confirmations
            let message = `<center>Category "${categoryObj.categoryName}" will be permanently deleted! Do you want to proceed ?</center>`;
            let options = {
                html: true, 
                okText: 'Yes, Proceed',
                cancelText: 'Cancel',
                animation: 'bounce', // Available: "zoom", "bounce", "fade"
            }
            this.$dialog.confirm(message, options)
            .then((dialog) => {
                this.deleteCategoryAction(categoryObj)
                .then((data) => {
                    if(!data.error){
                        this.color = "success"
                        // route user back to main categories page
                        this.$router.push({
                            name: 'main-categories'
                        }).catch((e) => {})
                    }
                    this.msg = data.msg
                })
                .catch((e) => {})
            })
            .catch((e) => {})
        },
        deleteSubCategoryFxn(theSubCategoryObj) {
            this.color = "danger"
            let subCategoryObj = {
                subCategoryId: theSubCategoryObj._id,
                subCategoryName: theSubCategoryObj.subCategory,
                categoryName: this.categoryName.toLowerCase(),
            }
            // vuejs-dialog usage for pop up confirmations
            let message = `<center>SubCategory "${subCategoryObj.subCategoryName}" will be permanently deleted! Do you want to proceed ?</center>`;
            let options = {
                html: true, 
                okText: 'Yes, Proceed',
                cancelText: 'Cancel',
                animation: 'bounce', // Available: "zoom", "bounce", "fade"
            }
            this.$dialog.confirm(message, options)
            .then((dialog) => {
                this.deleteSubCategoryAction(subCategoryObj)
                .then((data) => {
                    if(!data.error){
                        this.color = "success"
                    }
                    this.msg = data.msg
                })
                .catch((e) => {})
            })
            .catch((e) => {})
        },
    },
    computed: {
        ...mapGetters(['setMainSubCategories']),
        theSubCategories(){
            if(this.setMainSubCategories){
                return this.setMainSubCategories
            }
            return [] 
        },
    },
    components: {
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.fetchSubCategoriesFxn(this.categoryName)
        this.$emit('update:layout', LayoutShop);
    }
}
</script>
